import { AUX } from '../../hoc'
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class layout extends Component {

    render() {
        return (
            <AUX>
                {!this.props.loginpage ?
                    <main>
                        <div id="wrapper">
                            {this.props.sidebar ? <Sidebar /> : null}
                            <div className="content-page">
                                <div className="content">
                                    {this.props.header ? <Header /> : null}
                                    {this.props.children}
                                </div>
                                {this.props.footer ? <Footer /> : null}
                            </div>
                        </div>
                    </main> : this.props.children}
            </AUX>
        );
    }
}

export default withRouter(layout);
